import type {Mapper} from 'framework';
import type {ReplaceWorkoutExerciseResult} from '../../domain/workout';
import type {ReplaceWorkoutExerciseDto} from '../dto/workout.dto';
import type {WorkoutDtoToWorkoutMapper} from './workout-dto-to-workout.mapper';

export class ReplaceWorkoutExerciseDtoToResultMapper implements Mapper<
  ReplaceWorkoutExerciseDto,
  ReplaceWorkoutExerciseResult
> {
  constructor(private readonly workoutMapper: WorkoutDtoToWorkoutMapper) {}

  transform(dto: ReplaceWorkoutExerciseDto): ReplaceWorkoutExerciseResult {
    return {
      workout: this.workoutMapper.transform(dto.workout),
      workoutExerciseId: dto.workoutExerciseId,
    };
  }
}
